var exports = {
  "F": "unsatisfiedIcon__EYf1Ib",
  "K": "satisfiedIcon__g8PW-t",
};

module.exports = exports;
